import { UserRole } from '../../../types/generalType'
export interface IAuthInitialState {
  loading: boolean
  userInfo: UserAuth
  authForm: AuthFormType
  forgetPasswordForm: ForgetPasswordFormType
  changePassword: {
    loading: boolean
  }
  createOtp: {
    createOtpLoading: boolean
    createOtpStatus: boolean
  }
  resetPasswordWithOtp: {
    resetOtpLoading: boolean
    resetOtpStatus: boolean
  }
}

export type RegisterUser = {
  name: string
  family: string
  nationalCode: string
  mobile: string
  email: string
  password: string
  passwordRepeat: string
}

export type UserAuth = {
  userId: string
  accessToken: string
  exp: number
  role: UserRole[]
  provinceBrokerId: string
  name: string
  family: string
  nationalCode: string
  phoneNumber: string
}

export type UserAuthResponse = {
  access_token: string
  expires_in: number
  scope: string
  token_type: string
}

export enum AuthForm {
  LOGIN = 'login',
  Register = 'register',
  PublicPreReserve = 'publicPreReserve',
  AddPilgrim = 'publicPreReserveAddPilgrim',
}
export enum ForgetPasswordForm {
  LOGIN = 'login',
  ForgetPassword = 'forgetPassword',
}
export type AuthFormType = 'login' | 'register' | 'publicPreReserve' | 'publicPreReserveAddPilgrim'
export type ForgetPasswordFormType = 'login' | 'forgetPassword'

export type TChangePasswordData = {
  userId: string
  oldPassword: string
  password: string
  confirmPassword: string
}
